/**
 * 全局 z-index 分层常量（语义化，禁止在组件里使用裸数字）。
 *
 * 背景：退款/充值 Drawer 历史上为盖详情页内 SplitOrderTree（拆单树，1000 级）将 zIndex
 * 提到 1030，导致 Drawer 之上的 Modal.confirm（rock-modal 默认 1000）被盖住，下拉又手动
 * 顶到 1300 —— 逐层攀比。本常量收敛为语义分层，新弹层一律引用，不再往上加。
 *
 * 层级语义（从低到高）：
 * - detailFloat  < drawer：详情页内嵌浮层（拆单树等），低于所有 Drawer
 * - drawer       常规 Drawer（FormDrawer/BatchDrawer），保留 1030 以盖详情页拆单树
 * - drawerPopup  Drawer 内下拉/popover（Select dropdown 渲染到 body，需盖 Drawer 自身）
 * - modal        Drawer 之上的 Modal（确认/退回/废弃弹框），永远高于 drawer
 * - message      全局 Message
 */
export const Z_INDEX = {
  /** 详情页内嵌浮层（拆单树外层容器等） */
  detailFloat: 100,
  /** 常规 Drawer：FormDrawer/BatchDrawer */
  drawer: 1030,
  /** Drawer 内下拉弹层（Select dropdown 等） */
  drawerPopup: 1300,
  /** Drawer 之上的 Modal（确认/退回/废弃弹框） */
  modal: 1100,
  /** 全局 Message */
  message: 2000,
} as const;
